module.exports = __webpack_public_path__ + "img/podcastv2.9eeb65dc.png";